import { useEffect, useRef, useState } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { useMsal } from '@azure/msal-react';

const connectionString = process.env.REACT_APP_INSIGHTS;

const AppInsights = () => {
  const [applicationInsights, setApplicationInsights] = useState<
    ApplicationInsights | undefined
  >();
  const initialized = useRef(false);
  const { accounts } = useMsal();

  useEffect(() => {
    if (
      !initialized.current &&
      typeof connectionString === 'string' &&
      connectionString.length > 1
    ) {
      const appInsights = new ApplicationInsights({
        config: {
          connectionString,
          enableAutoRouteTracking: true,
        },
      });
      appInsights.loadAppInsights();
      // Collect unique users
      if (accounts[0]) {
        appInsights.setAuthenticatedUserContext(accounts[0].localAccountId);
      }
      appInsights.trackPageView();

      setApplicationInsights(appInsights);
      initialized.current = true;
    }
  }, [applicationInsights, accounts]);

  return null;
};

export default AppInsights;
